<div class="limited-text-area">
  <textarea
    [readonly]="isReadonly"
    [placeholder]="placeholder"
    [formControl]="control"
    [maxlength]="limit"
    [rows]="rows"
    [class.has-border]="hasBorder"
    [class.has-error]="errorMessage && control.touched"
    (blur)="onblur()"
    (focus)="onfocus()"
  ></textarea>
  <div class="message-limit" [class.has-error]="errorMessage && control.touched">{{ messageLength }}/{{ limit }}</div>
  @if (errorMessage && control.touched) {
    <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
  }
</div>
